import { useLocation, useSearchParams } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import { useRemixForm } from "remix-hook-form";

import SearchBar from "../../molecules/SearchBar";

import { Form } from "~/components/templates/form";
import { EApiParam } from "~/utilities/enums/ApiParam";
import {
  FilterSearchVirtualTourFormData,
  filterSearchVirtualTourSchema,
} from "~/utilities/schema/filter-search-virtual-tour";

export interface FilterSearchProps {
  disabled?: boolean;
}

const SectionVirtualSearchBar: React.FC<FilterSearchProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const handleFormInit = async (
    _methods: ReturnType<typeof useRemixForm<FilterSearchVirtualTourFormData>>
  ) => {};
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const defaultValues: Partial<FilterSearchVirtualTourFormData> = {
    keyword: searchParams.get(EApiParam.KEYWORD) || "",
  };

  return (
    <section
      data-name="virtual-tours"
      className="bg-darkGrey py-6 lg:bg-inherit lg:py-0"
    >
      <div className="container-fluid">
        <Form<FilterSearchVirtualTourFormData>
          validationSchema={filterSearchVirtualTourSchema}
          onMethodInit={handleFormInit}
          useFormProps={{
            mode: "onChange",
            defaultValues,
          }}
          action={location.pathname + location.search}
        >
          {({ register, formState: { errors } }) => (
            <SearchBar
              inputProps={{
                placeholder: t("search_project_placeholder"),
                disabled,

                ...register("keyword"),
              }}
              iconClass="block"
            />
          )}
        </Form>
      </div>
    </section>
  );
};

export default SectionVirtualSearchBar;
